import { types, isType } from "mobx-state-tree"
import { getAllCategories, getSingleCategory } from "../api-calls/categories"
import { getEventsByCategoryId } from "../api-calls/events"
import { Event } from "../models/Event"
import { Category } from "../models/Category"



const CategoriesStoreModel = types
    .model('CategoryStore', {
        loading: types.boolean,
        categories: types.map(Category),
        singleCategory: types.map(Category),
        categoryEvents: types.map(Event),
    })
    .actions(self => {
        return {
            queryCategories: async () => {
                self.resetCategories();
                getAllCategories().then((categories) => {
                    self.setCategories(categories);
                });
                self.setLoading(false);
            },
            setCategories: (categories) => {
                categories.sort((a,b) => {var nameA = a.title.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.title.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                      return -1;
                    }
                    if (nameA > nameB) {
                      return 1;
                    }
                  
                    // names must be equal
                    return 0;});
                for (let category of categories) {
                    self.categories.put(category);
                }
            },
            querySingleCategory: async (categoryId) => {
                self.resetSingleCategory();
                getSingleCategory(categoryId).then((category) => {
                    self.setSingleCategory(category);
                });
            },
            setSingleCategory: (category) => {
                self.singleCategory.put(category);
            },
            queryCategoryEvents: async (categoryId) => {
                self.setLoading(true);
                self.resetCategoryEvents();
                getEventsByCategoryId(categoryId).then((events) => {
                    self.setCategoryEvents(events);
                });
                self.setLoading(false);
            },
            setCategoryEvents: (events) => {
                for (let event of events) {
                    self.categoryEvents.put(event);
                }
            },
            setLoading: (loading) => {
                self.loading = loading;
            },
            resetCategoryEvents: () => {
                self.categoryEvents = {}
            },
            resetSingleCategory: () => {
                self.singleCategory = {}
            },
            resetCategories: () => {
                self.categories = {}
            },
        }
    });

const CategoriesStore = CategoriesStoreModel.create({
    loading: true,
    categories: {},
    singleCategory: {},
    categoryEvents: {},
});

export default CategoriesStore;


// WEBPACK FOOTER //
// ./src/stores/CategoriesStore.js